import React from "react";
import "./aboutme.css";
import myPhoto from "../img/myphoto.jpg";
const AboutMe = () => {
  return (
    <main className="section section_about_me">
      <div className="container">
        <h1 className="title-1">About Me</h1>
        <div className="about-me about-card">
          <div className="about-me__text">
            <div className="about-me__image" id="about-me__image">
              <img src={myPhoto} alt="Leonid Shamarin" />
            </div>
            <p>
              <strong>
                AI Automation Engineer (n8n / JavaScript / Python) — ERP/CRM and
                marketplace integrations. Full-stack developer with an AI focus.
              </strong>
              <br />
              <br />
              I build workflow automation, e-commerce integrations and
              self-hosted Python micro-services. For a pan-European multi-brand
              retailer that meant 350+ n8n and Windmill workflows, 5+
              FastAPI/Flask services running on Coolify, and integrations across
              11+ marketplaces — with the DevOps ownership that comes with
              running your own infrastructure: Docker, Hetzner, Cloudflare,
              GitHub auto-deploy.
              <br />
              <br />
              The integration work goes deep — Amazon SP-API, Odoo over
              JSON-RPC, Bitrix24, eBay, Mirakl — and the AI work is the part I care
              most about: category and content resolution with structured output
              and fallback chains, retrieval over document corpora, and agents
              that stop and ask a human before doing anything irreversible. My
              frontend background means I can deliver a system end to end,
              from the data pipeline to the interface someone actually uses.
            </p>
          </div>
        </div>
        <div className="resume">
          <p className="btn-resume">
            <a
              href="https://drive.google.com/drive/folders/1vemD8yjA8HDMHHj_nf95oonEV-hbIxdu"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Resume
            </a>
          </p>
        </div>
        <h2 className="title-3">Work Experience</h2>
        <section className="job about-card">
          <h3 className="job__role">AI / Automation Engineer</h3>
          <p className="job__meta">Self-employed · 08/2026 — present</p>
          <div className="discription_aboutme">
          <p>
            Independent projects: AI systems and integrations built end to end,
            each with its own evaluation, so the numbers are measured, not
            estimated.
          </p>
          <ul>
            <li>
              Doc to CRM: invoices and delivery notes (PDF or phone photo) into
              ledger entries. 90% fully correct on 40 documents; review routing
              88.9% recall, 0 false alarms.
            </li>
            <li>
              Inbox Agent: tool-calling agent that stops before irreversible
              actions. 6 irreversible actions attempted, 0 executed without a
              human.
            </li>
            <li>
              KB RAG Assistant: RAG over a private knowledge base, 122-question
              golden set, live on Hugging Face Spaces.
            </li>
            <li>
              Outbound Lead Engine: lead generation pipeline with LLM emails and
              fact checks. 29 of 30 emails valid on the first answer, $0.38 per
              1000.
            </li>
            <li>
              Shop Pulse: online-store dashboard with an AI assistant whose
              every number is checked against the data: 53 of 53 verified.
            </li>
            <li>
              Ad Watch: Meta Ads and Google Ads watchdog with Telegram approval
              buttons; creative fatigue found in 86.6% of cases at 100%
              precision, on mocks in real API formats.
            </li>
            <li>
              Temu, OpenCart and SAP sync: 0.1% of units sold beyond stock
              against 22% with naive stock updates, in a 30-day simulation.
            </li>
            <li>
              AI Shop Consultant: shopping assistant widget for an online store
              that finds, compares and explains products and fills the cart; on
              49 test queries every shown product in the right category and
              budget, honest "we don't have it" 4 of 4, median 3.2 s.
            </li>
          </ul>
          <div className="technologies">
            <h3 className="technologies-header">Technologies</h3>
            <ul className="tech-list">
              <li>Python</li>
              <li>FastAPI</li>
              <li>Pydantic</li>
              <li>PostgreSQL</li>
              <li>pytest</li>
              <li>Gemini</li>
              <li>Groq</li>
              <li>n8n</li>
              <li>Docker</li>
              <li>Vercel</li>
            </ul>
          </div>
          </div>
        </section>
        <section className="job about-card">
          <h3 className="job__role">
            Developer, n8n / JavaScript / Python
          </h3>
          <p className="job__meta">Hajus AG · 06/2025 — 07/2026</p>
          <div className="discription_aboutme">
          <ul>
            <li>
              Designed and maintained 350+ workflows in n8n.io and Windmill —
              autoposting, order processing, stock and price sync, and error
              monitoring across 11+ marketplaces (Amazon, Bol.com, eBay,
              Mirakl-based, OBI/VTEX, Metro DE, Praktiker.de, Pigu, Aukro,
              Okazii).
            </li>
            <li>
              Built 5+ production Python micro-services on Coolify (FastAPI /
              Flask + Playwright + Docker) — marketplace publishing, stock sync,
              UI automation with TOTP 2FA, signed-API integrations — replacing a
              single-VM point of failure with per-service health-checks, cron,
              memory limits and GitHub auto-deploy.
            </li>
            <li>
              Re-architected the OBI/VTEX auto-posting pipeline from n8n to
              Windmill: a 15-step product flow with 4 cron schedules, AI
              resolution of category, dimensions, attributes and image choice,
              and a Google-Sheets-backed state machine.
            </li>
            <li>
              Built a Pricing Intelligence system on Bitrix24 order data — it
              detects negative-margin products, fetches live competitor prices
              via SerpAPI, applies a custom pricing algorithm and writes HTML
              reports back to Bitrix24.
            </li>
            <li>
              Integrated Odoo (JSON-RPC), Bitrix24 and marketplace APIs into one
              pipeline for order fulfilment, invoicing and delivery
              confirmation.
            </li>
            <li>
              Ran ~28 Amazon SP-API processes on two seller accounts: stock and
              price via the Listings Items API, orders and shipment
              confirmation, Feeds, Reports, buyer messaging and restricted-data
              tokens.
            </li>
            <li>
              Developed an eBay ↔ Odoo messaging integration — fetching buyer
              messages, opening Odoo support tickets and replying back to eBay,
              closing the full customer communication loop.
            </li>
            <li>
              Implemented AI-powered categorisation and content generation
              (OpenAI, Google Gemini, xAI Grok including Vision) with structured
              output and fallback chains.
            </li>
            <li>
              Architected the AWS image pipeline (S3 + CloudFront + Thumbor)
              with content-hash deduplication, migrating off Cloudinary — cut
              hosting costs by ~70% and added marketplace-specific dynamic
              resizing.
            </li>
            <li>
              Established Bitrix24 error monitoring — improved reliability by
              40% and cut manual processing time by 60%.
            </li>
          </ul>
          <div className="technologies">
            <h3 className="technologies-header">Technologies</h3>
            <ul className="tech-list">
              <li>n8n.io</li>
              <li>Windmill</li>
              <li>Python</li>
              <li>FastAPI</li>
              <li>Flask</li>
              <li>JavaScript</li>
              <li>Playwright</li>
              <li>Docker</li>
              <li>Coolify</li>
              <li>Hetzner</li>
              <li>Cloudflare</li>
              <li>Odoo (JSON-RPC)</li>
              <li>Bitrix24</li>
              <li>Amazon SP-API</li>
              <li>VTEX</li>
              <li>Metro DE</li>
              <li>eBay</li>
              <li>Mirakl</li>
              <li>AWS</li>
              <li>Thumbor</li>
              <li>OpenAI</li>
              <li>Gemini</li>
              <li>Grok (Vision)</li>
              <li>SerpAPI</li>
              <li>pytest</li>
            </ul>
          </div>
          </div>
        </section>
        <section className="job about-card">
          <h3 className="job__role">Front-End Developer, internship</h3>
          <p className="job__meta">SoftServe LLC · 11/2023 — 11/2024</p>
          <div className="discription_aboutme">
          <ul>
            <li>
              Built responsive web applications in React and TypeScript with
              HTML and SCSS, backed by Node.js and MongoDB services.
            </li>
            <li>
              Worked in a cross-functional Scrum team: sprint planning, daily
              stand-ups, code reviews and retrospectives, delivering to sprint
              deadlines.
            </li>
            <li>
              Kept the codebase in Git and automated the build and test
              workflows in GitHub Actions.
            </li>
            <li>
              Covered components with unit tests in Jest, React Testing Library
              and Jasmine, and kept code quality under SonarQube.
            </li>
            <li>
              Took part in a volunteer project, picking up new technologies
              quickly and delivering under tight deadlines.
            </li>
          </ul>
          <div className="technologies">
            <h3 className="technologies-header">Technologies</h3>
            <ul className="tech-list">
              <li>React.js</li>
              <li>TypeScript</li>
              <li>JavaScript</li>
              <li>HTML</li>
              <li>SCSS</li>
              <li>Node.js</li>
              <li>MongoDB</li>
              <li>Redux</li>
              <li>Material-UI</li>
              <li>Jest</li>
              <li>React Testing Library</li>
              <li>Jasmine</li>
              <li>SonarQube</li>
              <li>Git</li>
              <li>GitHub Actions</li>
              <li>Figma</li>
              <li>Trello</li>
            </ul>
          </div>
          </div>
        </section>
        <section className="job about-card">
          <h3 className="job__role">Project Engineer</h3>
          <p className="job__meta">Eco-Techgroup LLC · 06/2016 — 10/2022</p>
          <div className="discription_aboutme">
          <p>
            Engineering company working on building services: power supply,
            ventilation and air conditioning.
          </p>
          <ul>
            <li>
              Designed electrical systems for buildings in AutoCAD: power supply,
              lighting and wiring schematics, from the first drawings to the
              final documentation set.
            </li>
            <li>
              Led engineering projects end to end: coordinated cross-functional
              teams, made site visits and kept projects on schedule.
            </li>
            <li>
              Reviewed project documentation and made sure it complied with
              building codes and safety standards.
            </li>
            <li>
              Prepared commercial offers and cost estimates, handled procurement
              of equipment and materials, and kept projects within budget.
            </li>
            <li>
              Kept in regular contact with clients on requirements, changes and
              project progress.
            </li>
          </ul>
          <div className="technologies">
            <h3 className="technologies-header">Skills</h3>
            <ul className="tech-list">
              <li>AutoCAD</li>
              <li>Electrical Design</li>
              <li>Project Management</li>
              <li>Technical Documentation</li>
              <li>Building Codes and Safety</li>
              <li>Cost Estimates</li>
              <li>Budget Management</li>
              <li>Procurement</li>
              <li>Client Communication</li>
              <li>Team Coordination</li>
            </ul>
          </div>
          </div>
        </section>
        <h2 className="title-3">Certificates</h2>
        <div className="sertificates-list">
          <ul>
            <li className="about-card">
              <h3 className="cert__title">
                IBM Generative AI Engineering Professional Certificate, date of
                issue - 08/2026
              </h3>
              <div className="sertificates_item">
                16 courses, IBM via Coursera
                <p className="btn-my">
                  <a
                    href="https://www.coursera.org/account/accomplishments/specialization/5OBWSAXNAZVU"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Generative AI Engineering with LLMs Specialization, date of
                issue - 08/2026
              </h3>
              <div className="sertificates_item">
                IBM via Coursera
                <p className="btn-my">
                  <a
                    href="https://www.coursera.org/account/accomplishments/specialization/KH4ITH2XH52M"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Google AI Professional Certificate, date of issue - 07/2026
              </h3>
              <div className="sertificates_item">
                7 courses, Google via Coursera
                <p className="btn-my">
                  <a
                    href="https://www.coursera.org/account/accomplishments/specialization/GRXNDXGMGTHC"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Anthropic: Claude Code 101, date of issue - 07/2026
              </h3>
              <div className="sertificates_item">
                Certificate of completion
                <p className="btn-my">
                  <a
                    href="https://verify.skilljar.com/c/fyedtsckkc8e"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Mastering Claude Code: From Setup to Real Projects, date of
                issue - 07/2026
              </h3>
              <div className="sertificates_item">
                SkillsBooster via Coursera
                <p className="btn-my">
                  <a
                    href="https://www.coursera.org/account/accomplishments/verify/8YPMYGZDBFP8"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Anthropic: AI Fluency — Framework & Foundations, date of issue -
                06/2026
              </h3>
              <div className="sertificates_item">
                Certificate of completion
                <p className="btn-my">
                  <a
                    href="https://verify.skilljar.com/c/5y6xb6hns8gn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Hugging Face: AI Agents Fundamentals, date of issue - 06/2026
              </h3>
              <div className="sertificates_item">
                Certificate of completion
                <p className="btn-my">
                  <a
                    href="https://drive.google.com/file/d/1z-SJgGFywpgo-VqEuDoshHmMwSznLC2z/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Google: AI Fundamentals, date of issue - 06/2026
              </h3>
              <div className="sertificates_item">
                Google via Coursera
                <p className="btn-my">
                  <a
                    href="https://www.coursera.org/account/accomplishments/verify/YUEBPTUSDHJ0"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Scrimba courses: AI-Powered Frontend Development and Prompt
                Engineering Mastery
              </h3>
              <div className="sertificates_item">
                Certificates credentials
                <p className="btn-my">
                  <a
                    href="https://drive.google.com/file/d/1XwQ0dcRDJqVUbAzB8D8THS23JAIf5PJS/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>

            <li className="about-card">
              <h3 className="cert__title">
                EF SET English Certificate (B2 Upper Intermediate), date of
                issue - 05/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series №w68yVi
                <p className="btn-my">
                  <a
                    href="https://cert.efset.org/w68yVi"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>

            <li className="about-card">
              <h3 className="cert__title">
                ITVDN course: TypeScript, date of issue - 03/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series TP №TP02980810
                <p className="btn-my">
                  <a
                    href="https://testprovider.com/ru/search-certificate/TP02980810"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                ITVDN course: Angular Advanced, date of issue - 02/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series TP №31045992
                <p className="btn-my">
                  <a
                    href="https://testprovider.com/ru/search-certificate/TP31045992"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                ITVDN course: Angular Essential, date of issue - 02/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series TP №01604026
                <p className="btn-my">
                  <a
                    href="https://testprovider.com/ru/search-certificate/TP01604026"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: COMPLETE WEBUI ENGINEER COURSE, date
                of issue - 01/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series IG №16496/2024
                <p className="btn-my">
                  <a
                    href="https://drive.google.com/file/d/12qgLuJCnsJge-YqHt120fTy76oDPFutk/view"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                ITVDN course: WordPress Essential, date of issue - 01/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series TP №44094371
                <p className="btn-my">
                  <a
                    href="https://testprovider.com/ru/search-certificate/TP44094371"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: ENGLISH ONLINE MARATHON, date of issue
                - 01/2024
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series QR №16617/2024
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: WEBUI DEVELOPER (INTERNSHIP), date of
                issue - 12/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series CH №16409/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: PRACTICAL REACT, date of issue -
                11/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series AN №15479/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: DEVOPS FUNDAMENTALS, date of issue -
                08/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials Series TP №13541/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                FreeCodeCamp course: JavaScript Algorithms and Data Structures,
                date of issue - 08/2023
              </h3>
              <div className="sertificates_item">
                Certificates credentials
                <p className="btn-my">
                  <a
                    href="https://freecodecamp.org/certification/Leonid_Shamarin/javascript-algorithms-and-data-structures"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: DATABASE FUNDAMENTALS, date of issue -
                06/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series QA № 12924/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Green Forest course: Pre-intermediate / A2 English course has
                been successfully completed, date of issue - 06/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - 165c932ef4d748c4ce6c31f648623ac0c1df4579
                <p className="btn-my">
                  <a
                    href="https://my.greenforest.com.ua/certificate/165c932ef4d748c4ce6c31f648623ac0c1df4579"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: JAVASCRIPT FUNDAMENTALS, date of issue
                - 04/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series RD № 12187/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Prometheus course: Fundamentals of project management, date of
                issue - 03/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - 1897a54ba74948a98ae971873ed84572
                <p className="btn-my">
                  <a
                    href="https://drive.google.com/file/d/1BdNFn1hTF9ofn1FyiIan4Vg3dbjyTl4y/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                SoftServe Academy course: HTML5/ CSS3/ JAVASCRIPT FUNDAMENTALS,
                date of issue - 02/2023
              </h3>
              <div className="sertificates_item">
                ID of credentials - Series EM № 11680/2023
                <p className="btn-my">
                  <a
                    href="https://career.softserveinc.com/en-us/certification/verification"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Genesis Tech course: Creation and development of IT products,
                date of issue - 11/2022
              </h3>
              <div className="sertificates_item">
                ID of credentials - 7129a3be-fa28-4a7f-8c55-ee19c9ebfc5d
                <p className="btn-my">
                  <a
                    href="https://genesis.theworkademy.com/uk/verifycertificate/?uuid=7129a3be-fa28-4a7f-8c55-ee19c9ebfc5d"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
            <li className="about-card">
              <h3 className="cert__title">
                Watch all the certificates on Google Drive
              </h3>
              <div className="sertificates_item">
                Certificates credentials
                <p className="btn-my">
                  <a
                    href="https://drive.google.com/drive/folders/1HmTlgvKdW3XtKHc_6xuCmTRQtIqBiuuJ?usp=drive_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    show credentials
                  </a>
                </p>
              </div>
            </li>
          </ul>
        </div>
        <div className="skills">
          <h2 className="title-3">Skills</h2>
          <ul className="skills-list">
          <li className="title-4">
            Workflow automation: n8n.io, Windmill, REST and webhook design
          </li>
          <li className="title-4">
            Languages: JavaScript, TypeScript, Python, Node.js
          </li>
          <li className="title-4">
            Python web: FastAPI, Flask, uvicorn, gunicorn, pydantic, pytest
          </li>
          <li className="title-4">
            AI: OpenAI, Google Gemini, xAI Grok (incl. Vision), Anthropic Claude,
            RAG, structured output and fallback chains
          </li>
          <li className="title-4">
            Browser automation: Playwright (Chromium), TOTP/2FA automation
          </li>
          <li className="title-4">
            DevOps: Docker, Coolify, Hetzner, Cloudflare, GitHub Actions
          </li>
          <li className="title-4">
            Cloud and images: AWS (S3, CloudFront, IAM, Lambda), Thumbor
          </li>
          <li className="title-4">
            ERP / CRM: Odoo (JSON-RPC), Bitrix24
          </li>
          <li className="title-4">
            Marketplaces: Amazon SP-API, eBay, Bol.com, Mirakl, VTEX (OBI), Metro DE,
            Praktiker.de, Aukro, Okazii, Pigu
          </li>
          <li className="title-4">
            Frontend: React.js, Angular, Redux, jQuery, HTML5, CSS3, SASS,
            TailwindCSS, Material-UI, Bootstrap
          </li>
          <li className="title-4">
            Data: Supabase, MongoDB, SQL, Firebase, Airtable, Google Sheets
            API, openpyxl
          </li>
          <li className="title-4">
            Testing: pytest, Jest, React Testing Library, SonarQube
          </li>
          </ul>
        </div>
        <div className="education">
          <h2 className="title-3">Education</h2>
          <ul>
            <li className="title-4">
              M.S. Computer Science (with Honors), European University (10/2022 -
              01/2024)
            </li>
            <li className="title-4">
              M.S. Energy and Electrical Engineering Systems, Lviv National
              Environmental University (09/2014 - 01/2016)
            </li>
            <li className="title-4">
              B.A. Energy and Electrical Engineering Systems, Lviv National
              Environmental University (09/2009 - 06/2013)
            </li>
          </ul>
        </div>
      </div>
    </main>
  );
};

export default AboutMe;
